import { useEffect } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";

/**
 * Surfaces service-worker lifecycle events.
 *
 * With `registerType: "prompt"` a new build waits until the user accepts, so
 * an update can never swap the app out mid-interaction.
 */
export function UpdatePrompt() {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      console.error("Service worker registration failed", error);
    },
  });

  useEffect(() => {
    if (!offlineReady) return;
    toast.success("Ready to work offline");
    setOfflineReady(false);
  }, [offlineReady, setOfflineReady]);

  useEffect(() => {
    if (!needRefresh) return;

    toast("A new version is available", {
      duration: Infinity,
      action: (
        <Button size="sm" onClick={() => void updateServiceWorker(true)}>
          Reload
        </Button>
      ),
      onDismiss: () => setNeedRefresh(false),
    });
  }, [needRefresh, setNeedRefresh, updateServiceWorker]);

  return null;
}
